
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'report-simple': {
    width: 11.8,
    height: 15.3,
    viewBox: '0 0 11.8 15.3',
    data: '<path pid="0" d="M11.3 15.3H.5c-.3 0-.5-.2-.5-.5V.5C0 .2.2 0 .5 0h5.9c.1 0 .3.1.4.1l4.9 5c.1.1.1.2.1.4v9.3c0 .3-.2.5-.5.5zM1 14.3h9.8V5.7L6.2 1H1v13.3z" _fill="#8390a0"/>'
  }
})
